import React, { useState, useEffect } from "react";
import { View } from "react-native";

import {
  Label,
  ScoreImage,
  Description,
} from "screens/question/themeA/types/nps";

import { styles } from "./styles";

export const EmojiNpsQuestion = props => {
  const { question, selectedOptions, selectOption, lang } = props;

  const [boxMap, setBoxMap] = useState({});

  useEffect(() => {
    const _boxMap = createBoxMap(question.options);
    setBoxMap(_boxMap);
  }, [question]);

  const descriptions = {
    positive: {
      text: "Would definitely recommend",
      text_urdu: "ضرور",
    },
    negative: {
      text: "Would not recommend",
      text_urdu: "بلکل نہیں",
    },
  };

  return (
    <View>
      <View style={styles.scoreList}>
        {question.options.map((option, index) => {
          const Box = boxMap[index] || MiddleBox;
          const label = {
            score: option[lang],
            selected: !!selectedOptions[option.virtual_id],
            onPress: () => selectOption(question, option),
          };
          return <Box key={option.virtual_id} label={label} />;
        })}
      </View>
      <View style={styles.descriptionContainer}>
        <Description text={descriptions.negative[lang]} align="left" />
        <Description text={descriptions.positive[lang]} align="right" />
      </View>
    </View>
  );
};

export const RangeLine = ({ pointer, below }) => {
  const style = [styles.commonLine];
  if (!below) {
    style.push(styles.rangeLine);
  }
  if (pointer === "start") {
    style.push(styles.rangeStart);
  }
  if (pointer === "end") {
    style.push(styles.rangeEnd);
  }
  return <View style={style} />;
};

const FirstBox = ({ label, pointerBelow }) => {
  return (
    <View style={styles.rangePadding}>
      <RangeLine pointer="start" />
      <Label label={label} />
      {pointerBelow && <RangeLine pointer="start" below />}
    </View>
  );
};

const LastBox = ({ label, pointerBelow, emoji }) => {
  return (
    <View style={styles.rangePadding}>
      <RangeLine pointer="end" />
      <Label label={label} />
      {pointerBelow && <RangeLine pointer="end" below />}
      {emoji && <ScoreImage style={styles.emojiOffset} image={emoji} />}
    </View>
  );
};

const MiddleBox = ({ label, emoji }) => {
  return (
    <View style={styles.rangePadding}>
      <RangeLine />
      <Label label={label} />
      {emoji && <ScoreImage image={emoji} />}
    </View>
  );
};

const createBoxMap = options => {
  const boxMap = {};
  let lastScore = 0;

  options.forEach((option, index) => {
    if (option.score != lastScore) {
      boxMap[index] = FirstBox;
      boxMap[index - 1] = LastBox;
      lastScore = option.score;
    }
  });

  const sadEmoji = require("assets/images/emoji-sad.png");
  const neutralEmoji = require("assets/images/emoji-neutral.png");
  const happyEmoji = require("assets/images/emoji-happy.png");

  boxMap[0] = props => <FirstBox {...props} pointerBelow />;
  boxMap[3] = props => <MiddleBox {...props} emoji={sadEmoji} />;
  boxMap[8] = props => <LastBox {...props} emoji={neutralEmoji} />;
  boxMap[10] = props => <LastBox {...props} emoji={happyEmoji} pointerBelow />;

  return boxMap;
};
